<svg viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_544_14447)">
<path d="M20.305 10.2304C20.305 9.55059 20.2499 8.86714 20.1323 8.19839H10.7V12.0492H16.1014C15.8773 13.2912 15.1571 14.3898 14.1025 15.088V17.5866H17.325C19.2173 15.8449 20.305 13.2728 20.305 10.2304Z" fill="#4285F4"/>
<path d="M10.7 20.0007C13.3971 20.0007 15.6716 19.1151 17.3287 17.5866L14.1063 15.0879C13.2097 15.6979 12.0522 16.0433 10.7037 16.0433C8.09486 16.0433 5.88285 14.2832 5.08917 11.9169H1.76379V14.4927C3.46139 17.8695 6.91904 20.0007 10.7 20.0007Z" fill="#34A853"/>
<path d="M5.0854 11.9169C4.66651 10.675 4.66651 9.33011 5.0854 8.08814V5.51236H1.7637C0.345367 8.33801 0.345367 11.6671 1.7637 14.4927L5.0854 11.9169Z" fill="#FBBC04"/>
<path d="M10.7 3.95805C12.1257 3.936 13.5036 4.47247 14.5362 5.45722L17.3912 2.60218C15.5834 0.904587 13.184 -0.0287217 10.7 0.000673888C6.91904 0.000673888 3.46139 2.13185 1.76379 5.51234L5.08549 8.08813C5.8755 5.71811 8.09119 3.95805 10.7 3.95805Z" fill="#EA4335"/>
</g>
<defs>
<clipPath id="clip0_544_14447">
<rect width="20" height="20" fill="white" transform="translate(0.5)"/>
</clipPath>
</defs>
</svg>
